export const DISCORD_URL = "https://discord.gg/XFrMdY9dNh";
export const BRAND = {
  name: "FLOW TWEAKS",
  slogan: "For Players, By Players.",
};
export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

